import React, { PureComponent } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Input } from "../Form/TextInput/TextInput";
import { Button } from "../Button/Button";
import { setCode } from "../../actions";

const CodeInputWrapper = styled.div``;

const CodeInputButton = styled(Button)`
  margin-top: 30px;
`;

class CodeInput extends PureComponent {
  state = {
    value: ""
  };

  componentDidMount() {
    const { setCode, match, history, code } = this.props;
    if (match && match.params && match.params.code) {
      setCode(match.params.code);
      history.push("/politicus");
    }
    if (code) {
      this.setState({ value: code });
    }
  }

  render() {
    const { value } = this.state;
    const { setCode } = this.props;

    return (
      <CodeInputWrapper>
        <Input
          label="Code *"
          placeholder=""
          name="title"
          onChange={e =>
            this.setState({ value: e.currentTarget.value.replace(/ /g, "") })
          }
          value={value}
        />

        <CodeInputButton onClick={() => setCode(value)}>
          Verzenden
        </CodeInputButton>
      </CodeInputWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCode: code => {
      dispatch(setCode(code));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(CodeInput);



// WEBPACK FOOTER //
// ./src/components/CodeInput/CodeInput.js